export default __webpack_public_path__ + "static/media/kassan.31d47e75.jpeg";